import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MessageSquareText, Sparkles, ShieldCheck, ChevronRight, Circle } from "lucide-react";
import { toast } from "sonner";
import { chatApi, apiError, getUser } from "../lib/api";

export default function ChatIntro() {
  const navigate = useNavigate();
  const [intro, setIntro] = useState(null);
  const isGuest = getUser()?.role === "invitado";
  const backTo = isGuest ? "/invitados" : "/mi-cuenta";

  useEffect(() => { chatApi.intro().then(setIntro).catch((e) => toast.error(apiError(e))); }, []);

  const available = intro?.availability?.available;

  return (
    <div className="min-h-screen bg-cream" data-testid="chat-intro-page">
      <header className="bg-navy">
        <div className="max-w-2xl mx-auto px-6 h-20 flex items-center justify-between">
          <button data-testid="chat-back-btn" onClick={() => navigate(backTo)} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold transition-colors">
            <ArrowLeft className="w-4 h-4" /> {isGuest ? "Volver" : "Mi cuenta"}
          </button>
          <img src="/logo-supera-light.png" alt="Supera" className="h-11 w-auto object-contain" />
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-6 py-10">
        <div className="flex items-center gap-3">
          <span className="w-12 h-12 rounded-xl bg-[var(--gold)] flex items-center justify-center">
            <MessageSquareText className="w-7 h-7 text-[#0A1C30]" />
          </span>
          <div>
            <p className="text-xs font-extrabold tracking-[0.25em] text-[#B99B2E]">COMUNICACIÓN</p>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#0A1C30]">Chat Privado Supera</h1>
          </div>
        </div>

        <div className="mt-6 rounded-3xl bg-navy p-6 md:p-8 text-white relative overflow-hidden">
          <ShieldCheck className="absolute -right-3 -top-3 w-24 h-24 text-white/5" />
          <p className="text-[15px] leading-relaxed text-white/90">
            {intro?.welcome_message || "Cargando..."}
          </p>
          {intro && (
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-bold">
              <Circle className={`w-2.5 h-2.5 ${available ? "fill-[#22A860] text-[#22A860]" : "fill-[#E9A400] text-[#E9A400]"}`} />
              {available ? "Staff Supera disponible ahora" : "Staff no disponible en este momento"}
            </div>
          )}
        </div>

        <p className="mt-8 text-sm font-bold text-[#6B7688]">¿A dónde quieres ir?</p>
        <div className="mt-3 space-y-3">
          <button data-testid="go-staff-chat" onClick={() => navigate("/chat/staff")} className="w-full group flex items-center gap-4 rounded-3xl bg-white ring-1 ring-black/5 p-5 text-left hover:shadow-xl transition-all">
            <span className="w-14 h-14 rounded-2xl bg-[#0A1C30] flex items-center justify-center flex-shrink-0">
              <MessageSquareText className="w-7 h-7 text-gold" />
            </span>
            <span className="flex-1">
              <span className="block text-lg font-extrabold text-[#0A1C30]">Ir a Chat con staff Supera</span>
              <span className="block text-sm text-[#6B7688]">Habla en tiempo real con un asesor para tu seguimiento personalizado.</span>
            </span>
            <ChevronRight className="w-6 h-6 text-[#E9A400] transition-transform group-hover:translate-x-1" />
          </button>

          <button data-testid="go-assistant-chat" onClick={() => navigate("/asistente")} className="w-full group flex items-center gap-4 rounded-3xl bg-white ring-1 ring-black/5 p-5 text-left hover:shadow-xl transition-all">
            <span className="w-14 h-14 rounded-2xl bg-[var(--gold)] flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-7 h-7 text-[#0A1C30]" />
            </span>
            <span className="flex-1">
              <span className="block text-lg font-extrabold text-[#0A1C30]">Ir a Chat Asistente Virtual</span>
              <span className="block text-sm text-[#6B7688]">Resuelve dudas operativas de Supera al instante, 24/7.</span>
            </span>
            <ChevronRight className="w-6 h-6 text-[#E9A400] transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
